function x(t) {
  const n = new Set(t);
  return (e) => n.has(e);
}
function A(t, ...n) {
  try {
    return t == null ? void 0 : t(...n);
  } catch (e) {
    console.error(e);
  }
}
const f = (t) => {
  Promise.resolve().then(t);
}, P = queueMicrotask ?? f, o = (t) => (n) => typeof n === t, d = o("object"), a = o("bigint"), u = o("boolean"), s = o("function"), p = o("number"), w = o("string"), I = o("symbol"), g = o("undefined"), c = (t) => t === null, R = (t) => c(t) || g(t), { isArray: M } = Array, i = (t) => d(t) && !c(t) && !M(t), q = (t) => Number.isInteger(t), k = (t) => a(t) || u(t) || p(t) || w(t) || I(t) || g(t) || c(t), B = (t) => i(t) && s(t.then), F = (t) => i(t) && s(t.then) && s(t.catch) && s(t.finally), O = (t) => i(t) && s(t.next), S = (t) => i(t) && s(t.next) && s(t.throw) && s(t.return), T = (t) => t != null, N = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let j = (t, n, e) => {
  let h = (2 << Math.log2(t.length - 1)) - 1, m = -~(1.6 * h * n / t.length);
  return (l = n) => {
    let r = "";
    for (; ; ) {
      let b = e(m), y = m | 0;
      for (; y--; )
        if (r += t[b[y] & h] || "", r.length >= l) return r;
    }
  };
};
const U = j(N, 21, (t) => {
  let n = globalThis.crypto;
  return n === void 0 && (n = require("node:crypto").webcrypto), n.getRandomValues(new Uint8Array(t));
}), C = (t, n) => (e) => Math.min(Math.max(e, t), n);
export {
  x as arrayHas,
  P as asap,
  C as createInRange,
  M as isArray,
  a as isBigint,
  u as isBoolean,
  s as isFunction,
  S as isGenerator,
  q as isInteger,
  O as isIterator,
  R as isNill,
  c as isNull,
  p as isNumber,
  i as isObject,
  d as isObjectRaw,
  k as isPrimitive,
  F as isPromise,
  B as isPromiseLike,
  w as isString,
  I as isSymbol,
  g as isUndefined,
  U as nanoid,
  T as nonNullable,
  A as safeCallback
};
